import { render, staticRenderFns } from "./NotificationTemplatesModal.vue?vue&type=template&id=1a026ccc&scoped=true"
import script from "./NotificationTemplatesModal.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatesModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplatesModal.vue?vue&type=style&index=0&id=1a026ccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a026ccc",
  null
  
)

export default component.exports